const withSlug = (base: string, slug?: string | null) =>
    slug ? `${base}/${slug}` : base;

export const RoutePaths = {
    home: () => '/',

    people: {
        root: () => '/people',
        // /people/{id}/{name-slug}. The slug is cosmetic and optional.
        detail: (id: string, slug?: string | null) =>
            withSlug(`/people/${id}`, slug),
        detailRoute: () => '/people/:id/:slug?',
        tree: (id: string) => `/people/${id}/tree`,
        treeRoute: () => '/people/:id/tree',
        photos: (id: string) => `/people/${id}/photos`,
        photosRoute: () => '/people/:id/photos',
        edit: (id: string) => `/people/${id}/edit`,
        editSection: (id: string, section: string) =>
            `/people/${id}/edit/${section}`,
        editRoute: () => '/people/:id/edit/*'
    },

    tree: () => '/tree',
    gallery: () => '/gallery',

    surnames: {
        root: () => '/surnames',
        detail: (surname: string) => `/surnames/${encodeURIComponent(surname)}`,
        detailRoute: () => '/surnames/:surname'
    },

    accounts: {
        login: () => '/login',
        passwordlessLogin: () => '/passwordless-login'
    },

    // The ukbarter.com URL shapes, kept so old bookmarks and search results
    // still land on the right person.
    legacy: {
        familyTree: () => '/family-tree',
        person: () => '/family-tree/index/:id/:slug?'
    },

    notFound: () => '*'
};

export type RoutePaths = typeof RoutePaths;
